import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../../LoadingSpinner';
import { Icon } from '@iconify/react';
import './Jobs.css';

const Jobs = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('Government Jobs');
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");

  useEffect(() => {
    // Simulate data fetching
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const NaviconStyle = {
    marginRight: '10px',
    marginTop: '10px',
    marginLeft: '10px',
  };

  // Map tabs to iframe sources
  const tabSources = {
    'Government Jobs': 'https://www.spcommunity.org.za/category/jobs/public-service/',
  'Companies Hiring': 'https://jobs.spcommunity.org.za',
   // 'Remote Jobs': 'https://www.spcommunity.org.za/category/horoscopes/',
    
  };

  return isLoading ? (
    <LoadingSpinner />
  ) : (
  


    <div className="jobs-container">
      
      <div className="top-nav">
        {Object.keys(tabSources).map((tab) => (
          <button
            key={tab}
            className={`nav-tab ${activeTab === tab ? 'active' : ''}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
        
      </div>
     
      <iframe
        src={tabSources[activeTab]}
        style={{ width: '100%', height: '100vh', border: 'none', overflow: 'auto' }}
        title={activeTab}
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </div>
    
  );
};

export default Jobs;

  